import { render, staticRenderFns } from "./manualDataCollection.vue?vue&type=template&id=34cf304c&scoped=true"
import script from "./manualDataCollection.vue?vue&type=script&lang=js"
export * from "./manualDataCollection.vue?vue&type=script&lang=js"
import style0 from "./manualDataCollection.vue?vue&type=style&index=0&id=34cf304c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf304c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34cf304c')) {
      api.createRecord('34cf304c', component.options)
    } else {
      api.reload('34cf304c', component.options)
    }
    module.hot.accept("./manualDataCollection.vue?vue&type=template&id=34cf304c&scoped=true", function () {
      api.rerender('34cf304c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/otherMarket/views/manualDataCollection.vue"
export default component.exports